export default {
    listagem: {
        titulo_pagina: 'Disposable Results',
        table: {
            empty: 'No Vns found',
            nome: 'Vns',
            empresa: 'Company',
            resultado_descartavel: 'Disposable Result',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            editar: 'Edit Disposable Results'
        },
        fields: {
            vns: {
                label: 'Vns',
                description: 'Vns name'
            },
            report_trash: {
                label: 'Disposable Results',
                description: 'Results that will be discarded by vns'
            },
            botao_salvar : 'Save Disposable Results'
        },
        update: {
            success: 'Disposable results updated successfully!',
            error: 'Error updating disposable results!'
        }
    }
}